export const HTTP_SUCCESS = 200;
